module.exports = __webpack_public_path__ + "static/img/son2_active.cd28e333.jpg";